import clsx from 'clsx';
import { Box, Button, Text } from '@optiaxiom/react';

import { styles } from './SuggestionItem.css';

type SuggestionItemProps = {
  iconBefore?: React.ReactNode;
  iconAfter?: React.ReactNode;
  label: string;
  isAction?: boolean;
  isSelected?: boolean;
  isEditFocused?: boolean;
  onClick?: () => void;
  onEditClick?: () => void;
};

export function SuggestionItem({
  iconBefore,
  iconAfter,
  label,
  onClick,
  isAction,
  isSelected,
  isEditFocused,
  onEditClick,
}: SuggestionItemProps) {
  return (
    <Button
      w="full"
      icon={iconBefore}
      iconPosition="start"
      onClick={onClick}
      appearance="subtle"
      justifyContent="start"
      className={isSelected ? styles.suggestionItemSelected : styles.suggestionItem}
      bg={isSelected ? 'bg.default.hovered' : undefined}
      style={{ minHeight: '2rem' }}
      addonAfter={
        iconAfter ? (
          <Box
            className={clsx(styles.iconAfter, {
              [styles.iconAfterFocused]: isEditFocused,
            })}
            onClick={e => {
              e.stopPropagation();
              onEditClick?.();
            }}
          >
            {iconAfter}
          </Box>
        ) : undefined
      }
    >
      <Text color={isAction ? 'fg.secondary' : 'fg.default'} fontSize="sm" truncate>
        {label}
      </Text>
    </Button>
  );
}
